export const DATE_FULL_AND_TIME_FORMAT = 'D/MM/YYYY hh:mm A'
export const DATE_FULL_DISPLAY_AND_TIME_FORMAT = 'DD/MM/YYYY h:mm a'
export const DATE_FULL_DISPLAY_FORMAT = 'DD/MM/YYYY'
export const DATE_FULL_SAVE_DISPLAY_FORMAT = 'DD-MM-YYYY'
export const DATE_FULL_SAVE_FORMAT = 'YYYY-MM-DD'
export const DATE_MMM_FORMAT = 'D MMM YYYY'
export const DATE_YEAR_MONTH_DISPLAY_FORMAT = 'MM/YYYY'
export const DATE_YEAR_MONTH_SAVE_FORMAT = 'YYYY-MM'
export const HOURS_FORMAT = 'h:mma'
